import { Book16Regular, ChevronDown16Regular, ChevronUp16Regular } from '@fluentui/react-icons';
import * as React from 'react';
import localeService from 'src/dataServices/LocaleService';
import { CitationsContext } from './AssistantMessageWithCitations';

export interface Citation {
  sourceName: string;
  sourceUrl: string;
}

const CitationsDisplayComponent: React.FC = () => {
  const citationsContext = React.useContext(CitationsContext);
  const citations = citationsContext?.citations ?? [];
  const [expanded, setExpanded] = React.useState(false);

  if (!citations || citations.length === 0) {
    return null;
  }

  return (
    <div className="copilot-citations">
      {expanded && (
        <div className="copilot-citations-list">
          {citations.map((citation, index) => (
            <div key={index} className="copilot-citation-item">
              <a
                href={citation.sourceUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="copilot-citation-link"
                title={citation.sourceUrl}
              >
                <span className="copilot-citation-title">
                  {citation.sourceName ?? citation.sourceUrl.split('/').pop()}
                </span>
              </a>
            </div>
          ))}
        </div>
      )}
      <button
        className="copilot-citations-toggle"
        onClick={() => setExpanded(!expanded)}
        aria-expanded={expanded}
        aria-label={citations.length === 1
          ? localeService.getText('ContactUs', 'CitationsAriaLabel')
          : localeService.getText('ContactUs', 'CitationsAriaLabelPlural')?.replace('{count}', String(citations.length))}
      >
        <Book16Regular />
        <span>
          {citations.length === 1
            ? localeService.getText('ContactUs', 'CitationsSingleSource')
            : localeService.getText('ContactUs', 'CitationsMultipleSources')?.replace('{count}', String(citations.length))}
        </span>
        {expanded ? <ChevronUp16Regular /> : <ChevronDown16Regular />}
      </button>
    </div>
  );
};

export const CitationsDisplay = React.memo(CitationsDisplayComponent);
